import * as THREE from "three";
import {MathUtils} from "three";

import {GenerateDecal} from "./generateDecal";
import {createTexture} from "./createTexture";


export async function generateSection(section, product) {
	
	const target = window.threeViewer.product.getObjectByName("engraving_target");
	// Init variables
    const width = section.width / 1000
    const height = section.height / 1000
	const {chordWidth, circumference, angleRad} = calculateDecalPlaneWidth(width, target)
	
	window.sections = window.section || {}
	window.sections[section.sectionId] = {chordWidth, circumference, angleRad}
    const size = new THREE.Vector3(chordWidth, height, 0.1)
    
    const angle = MathUtils.degToRad(section.sectionAngle)
    const radialAngle = MathUtils.degToRad(section.radialAngle)
    
    const offsetY = section.offsetY / 1000
    const offsetX = section.offsetX / 1000
    
    const name = section.name
    const id = section.sectionId
	
    
    // Create section plane
    let plane = new THREE.PlaneGeometry(chordWidth, height, 1, 1)
	
	plane.userData.radialAngle = radialAngle
	
	
    let material = new THREE.MeshBasicMaterial({
        color: 0xfff,
        side: THREE.DoubleSide,
        transparent: true,
        opacity: 1,
        alphaTest: 0.1
    });
    let sectionPlane = new THREE.Mesh(plane, material)
    
    // Group section plane and rotate it by radial angle
    let group = new THREE.Group()
    group.add(sectionPlane)
    group.rotateY(radialAngle)
    
    // Set position of section plane
    sectionPlane.rotateZ(angle)
    sectionPlane.position.x = offsetX
    sectionPlane.position.y = offsetY
    sectionPlane.position.z = product.center
    
    // Crate texture and material
    let textures = await createTexture(width, height, name)
    
    let texture = textures.normal
    const sectionMaterial = new THREE.MeshBasicMaterial({
        // side: THREE.DoubleSide,
        transparent: true,
        opacity: 1,
        alphaTest: 0.1,
        polygonOffset: true,
        polygonOffsetFactor: -2,
    })
    sectionMaterial.map = texture
    
    // Generate decal
    let decal = new GenerateDecal({
        size: size,
        material: sectionMaterial,
        plane: sectionPlane,
        type: "section",
        name: name,
        userData: {
            id: id,
            name: name,
            radialAngle: radialAngle,
            angle: angle,
            textures: textures,
            offsetX: section.offsetX,
            offsetY: section.offsetY,
            width: section.width,
            height: section.height,
            productSize: window.threeViewer.productSize,
        },
        layer: 1,
    })
    decal.update = () => {
    }
    
    // Return decal if no error
    if (!decal.error) {
        
       
        // decal.update = decalMap.update
        //decal.highlight.off(true)
        //decal.highlight.on(0)
        return decal
    } else {
        return null
    }
    
}


const calculateDecalPlaneWidth = (sectionWidthMM, engravingTarget) => {
	if (!engravingTarget) return {chordWidth : sectionWidthMM, circumference : null, angleRad: null};
	
	
	const bbox = new THREE.Box3().setFromObject(engravingTarget);
	const size = new THREE.Vector3();
	bbox.getSize(size);
	
	const diameter = Math.max(size.x, size.z);
	const radius = diameter / 2;
	
	const circumference = Math.PI * diameter;
	//console.log("diameter: ", diameter, "circumference:", circumference, "1/4:" ,circumference/4)
	
	
	const angleFraction = sectionWidthMM / circumference;
	const angleRad = angleFraction * Math.PI * 2;
	
	const chord =  2 * radius * Math.sin(angleRad / 2);
	
	return {chordWidth : chord, circumference : circumference, angleRad: 360 * angleFraction};
};